module.exports = __webpack_public_path__ + "images/circle-3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/circle-3.png
// module id = 841
// module chunks = 124